/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import DocumentHead from 'data/document-head';
import Topbar from 'modules/me/topbar';
import CurrentVisualDeckPlanCard from './index/current-visual-deck-plan-card';
import { hasScheduledChanges } from 'state/current-visual-deck/selectors';
import ScheduledChangesCard from './index/scheduled-changes';
import VisualDeckDetailsCard from './index/visual-deck-details-card';
import { Stack, Box } from '@towersystems/towersystems-design-system';
import AnnotatedSection from 'components/annotated-section';

/**
 * Style dependencies
 */
import './styles.scss';

const VisualDeck = (props) => {
    return (
        <Box>
            <DocumentHead title='Billing - Manage Visual Deck Plan - Tower Systems' />
            <Topbar title='Visual Deck Plan' subTitle='Manage your Visual Deck plan' selected='visual-deck'>

            </Topbar>
            <Main padding='xxlarge'>
                <Stack space='xlarge' dividers>
                    <AnnotatedSection>
                        <AnnotatedSection.Annotation
                            title='Subscription Details'
                            description='Your current Visual Deck plan details.'
                        />
                        <AnnotatedSection.Content>
                            <CurrentVisualDeckPlanCard />
                            {props.hasScheduledChanges && <ScheduledChangesCard />}
                        </AnnotatedSection.Content>
                    </AnnotatedSection>
                </Stack>
            </Main>
        </Box>
    );
};

export default connect(
    (state) => ({
        hasScheduledChanges: hasScheduledChanges(state),
    }),
    {},
)(VisualDeck);
